import { ArrowForward, FolderCopy, Search } from "@mui/icons-material";
import { Box, Button, Grid, IconButton, Paper, Tab, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridColDef, GridOverlay, GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid';
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Api from "../../Api";
import { IComboBoxOption, IContract, IContractTableOptions, IContractVariation } from "../../interfaces";
import { BreadcrumbBar } from "../Breadcrumb";
import { TabPanel } from "../Shared/TabPanel";
import { ContractVariations } from "./ContractVariations";
import "./index.scss";

export const Contracts = ({ ...props }) => {

    const [searchQuery, setSearchQuery] = useState<string>("");
    const [value, setValue] = useState(0);


    const [selectedContract, setSelectedContract] = useState<IComboBoxOption>();
    const [contractVariations, setContractVariations] = useState<IContractVariation[]>();
    const contractRef = useRef(null);
    const variationRef = useRef(null);

    const onSelectContract = (contract: IContract | undefined) => {

        if (contract) {

            let contractId: string = contract.contractId ?? "";

            if (selectedContract && selectedContract.id === contractId)
                setSelectedContract(undefined);
            else
                setSelectedContract({
                    id: contractId,
                    value: contract.reference ?? "No Reference"

                });


            //Api.Contracts.Variation.getByContractId(contractId).then((data) => {
            //    let cvs = data as IContractVariation[];
            //    setContractVariations(cvs);
            //});

        } else {
            setSelectedContract(undefined);
            setContractVariations(undefined);
        }

    }


    useEffect(() => {

        let target = (selectedContract ? (variationRef.current as unknown) : (contractRef.current as unknown)) as HTMLDivElement

        if (target)
            target.scrollIntoView();

    }, [contractVariations])

    return (
        <div>
            <BreadcrumbBar
                current={"Contract / Lease"}
                previous={[]}
            />
            <Box ref={contractRef} />
            <Grid container sx={{ my: 3 }} alignItems="flex-end">
                <Grid xs item>
                    <Button
                        component={Link}
                        variant="contained"
                        to={"/contract/create"}
                    >
                        New Contract / Lease
                    </Button>
                </Grid>
                <Grid xs={"auto"} item>
                    <TextField
                        label={<><Search /> Search</>}
                        variant="standard"
                        value={searchQuery}
                        type="search"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setSearchQuery(e.target.value)
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container sx={{ my: 3 }}>
                <Grid item xs={12}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={(_, value) => {
                            setValue(value);
                            onSelectContract(undefined);
                        }} aria-label="c-table-tabs">
                            <Tab
                                label="Pending"
                                id={`c-table-tab-${0}`} />
                            <Tab
                                label="Live"
                                id={`c-table-tab-${1}`}
                            />
                        </Tabs>
                    </Box>
                </Grid>
                <Grid item xs={12}>


                    {[0, 1].map(i => {
                        return (
                            <TabPanel value={value} index={i}>
                                <Box>
                                    <ContractsTable
                                        selectedContractId={selectedContract ? selectedContract.id : null}
                                        onSelectContract={onSelectContract}
                                        searchQuery={searchQuery}
                                        open={i === 0}
                                    />
                                </Box>
                                <Box sx={{ mt: 2 }} ref={variationRef}>


                                    {selectedContract &&
                                        <ContractVariations
                                            selectedContract={selectedContract}
                                            searchQuery={searchQuery}
                                            onShowAll={(e) => {
                                                onSelectContract(undefined);
                                                e.stopPropagation();
                                            }}
                                        />
                                    }


                                </Box>
                            </TabPanel>
                        );
                    })}



                </Grid>
            </Grid>
        </div>
    );
}

export const ContractsTable: React.FC<IContractTableOptions> = ({
    selectedContractId,
    onSelectContract,
    searchQuery,
    open,
    ...props }) => {

    useEffect(() => {

        Api.Contracts.getByStatus(open ? "open" : "closed").then(x => {
            setContracts(x as IContract[])
            setDataLoading(false);
        });

    }, []);

    useEffect(() => { }, [selectedContractId])

    const [contracts, setContracts] = useState<IContract[]>([]);
    const [dataLoading, setDataLoading] = useState<boolean>(true);

    return (
        <Grid container sx={{ height: selectedContractId ? '10em' : '58vh' }}>
            <Paper sx={{ width: '100%' }} elevation={0}>
                <DataGrid
                    rows={contractRows(contracts, searchQuery, selectedContractId)}
                    getRowId={(row) => row.contractId}
                    columns={contractColumns(selectedContractId)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    components={{ NoRowsOverlay: () => emptyContractsTable(dataLoading) }}
                    loading={dataLoading}
                    initialState={{
                        sorting: {
                            sortModel: [{ field: 'reference', sort: 'desc' }]
                        },
                        pagination: {
                            pageSize: 10
                        }
                    }}

                    onRowClick={onSelectContract ? (e: any) => { onSelectContract(e.row as IContract) } : undefined}
                />
            </Paper>

        </Grid>

    );
}

const emptyContractsTable = (dataLoading: boolean) => {
    return <GridOverlay> {dataLoading ? "Loading contract / lease spare lists." : "No contract / lease spare lists."}</GridOverlay>
}

const contractColumns = (selected: string | null) => {

    return [

        {
            field: 'reference', headerName: 'Reference', flex: 1, renderCell: (params: GridRenderCellParams) => {
                return <Link to={"/contract/update/" + params.row.contractId}>{params.row.reference ?? "No Reference"}</Link>
            }
        },
        { field: 'statusName', headerName: 'Status', flex: 2 },

        {
            field: 'classes', headerName: 'Vehicle Class', flex: 1, renderCell: (params: GridRenderCellParams) => {
                return <Tooltip title={params.row.classes}>
                    <span>{params.row.classes}</span>
                </Tooltip>
            }
        },
        { field: 'requestor', headerName: 'Requested By', flex: 1 },
        {
            field: 'contractManager', headerName: 'Procurement Manager', flex: 1, renderCell: (params: GridRenderCellParams) => {
                return <span>{params.row.contractManager ? params.row.contractManager.value : ``}</span>
            }
        },
        {
            field: 'categoryManager', headerName: 'Commercial Manager', flex: 1, renderCell: (params: GridRenderCellParams) => {
                return <span>{params.row.categoryManager ? params.row.categoryManager.value : ``}</span>
            }
        },
        {
            field: 'latestVariation', headerName: 'Latest Variation', flex: 1, renderCell: (params: GridRenderCellParams) => {

                let highlight = selected !== null ? selected === params.row.contractId : false;

                return <span>
                    <Tooltip title="show all contract variations" placement="right" >

                        <IconButton sx={{ mr: '1em' }}>
                            <Typography color={highlight ? "primary" : "TextGrey"}>

                                <FolderCopy />
                            </Typography>

                        </IconButton>
                        {/*<Checkbox*/}
                        {/*    checked={selected !== null ? selected === params.row.contractId : false}*/}
                        {/*/>*/}
                    </Tooltip>
                    <Link to={`/contractvariation/update/${params.row.contractId}/${params.row.latestVariationId}`}>{params.row.latestVariation ?? ``}</Link>

                </span>
            }
        },
        {
            field: 'nextAudit',
            headerName: 'Next Audit',
            flex: 0,
            renderCell: (params) => { return (params.row?.nextAudit) ? new Date(params.row?.nextAudit).toLocaleDateString('en-gb') : `` }
        },
        {
            field: 'dateCreated',
            headerName: 'Created',
            flex: 0,
            renderCell: (params) => { return (params.row?.dateCreated) ? new Date(params.row?.dateCreated).toLocaleDateString('en-gb') : `` }
        },

        {
            field: 'edit', headerName: '', renderCell: (params: GridRenderCellParams) => {
                return <IconButton component={Link} to={"/contract/update/" + params.row.contractId}>
                    <ArrowForward />
                </IconButton>
            }
        }
    ] as GridColDef[]
}

const contractRows = (contracts: IContract[], searchQuery: string, selected: string | null) => {

    if (selected) return contracts.filter(x => x.contractId === selected);

    return contracts.filter(x => {
        let queryable = `${x.reference} ${x.statusName} ${new Date(x.dateCreated ?? "").toLocaleDateString('en-gb')}`;
        return queryable.includes(searchQuery);
    });
}

